{
	"onlineAvailability": [
		{ "state": "NONE", "textForm": ""},
		{ "state": "AVAILABLE", "textForm": "Online auf Lager" },
		{ "state": "PREORDER", "textForm": "Online vorbestellbar" },
		{ "state": "PROCURABLE", "textForm": "Artikel ist vom Fachmarkt beschaffbar" },
		{ "state": "SOLD_OUT", "textForm": "Das von Ihnen ausgewählte Produkt ist ausverkauft." },
		{ "state": "NOT_IN_STORE", "textForm": "Artikel aktuell im Markt nicht verfügbar" },
		{ "state": "NEXT_DAYS_AVAILABLE", "textForm": "Lieferzeit in ca. 2-5 Tagen" },
		{ "state": "ONLY_IN_STORE", "textForm": "Nur im Fachmarkt erhältlich" },
		{ "state": "NOT_AVAILABLE", "textForm": "Artikel ist derzeit nicht verfügbar" }
	],
	"onlineButtonAction": [
		{ "state": "NONE", "textForm": "" },
		{ "state": "SOON_TM", "textForm": "Gleich wieder verfügbar", "icon":"clock-nine-regular" },
		{ "state": "ORDER", "textForm": "In den Warenkorb", "icon":"cart-shopping-solid" },
		{ "state": "ORDER_IN_ADVANCE", "textForm": "Jetzt online vorbestellen",	"icon":"cart-shopping-solid" }
	],
	"storeAvailability": [
		{ "state": "NONE","textForm": "" },
		{ "state": "AVAILABLE", "textForm": "Gleich abholen oder wir liefern" },
		{ "state": "PREORDER", "textForm": "Im Markt vorreservierbar" },
		{ "state": "PROCURABLE", "textForm": "Artikel ist vom Fachmarkt beschaffbar" },
		{ "state": "SOLD_OUT", "textForm": "Das Produkt ist ausverkauft." },
		{ "state": "NOT_IN_STORE", "textForm": "Artikel aktuell im Markt nicht verfügbar" },
		{ "state": "NEXT_DAYS_AVAILABLE", "textForm": "vor Ort in $days Tagen abholbereit" },
		{ "state": "ONLY_IN_STORE", "textForm": "Nur im Fachmarkt erhältlich" },
		{ "state": "NOT_AVAILABLE",	"textForm": "Artikel ist derzeit nicht verfügbar" },
        { "state": "ALTERNATIVE_STORE", "textForm": "Dieser Artikel ist nur in anderen Fachmärkten sofort verfügbar" }
	],
	"storeButtonAction": [
		{
			"state": "SOON_TM",
			"textForm": "Gleich wieder verfügbar",
			"icon": "clock-nine-regular"
		},
		{ "state": "NONE", "textForm": "" },
		{
			"state": "RESERVE",
			"textForm": "Sofort abholen / regional liefern lassen",
			"directLink": "#1946cb49-f42c-4e42-b13a-05016fed4c59",
			"icon":"location-dot-solid"
		},
		{
			"state": "REQUEST_ADVICE",
			"textForm": "Jetzt beraten lassen",
			"directLink": "#37ea1528-1b42-4055-bf3e-b4eac38a5339",
			"icon":""
		},
		{
			"state": "REQUEST_PRICE",
			"textForm": "Jetzt Preis anfragen",
			"directLink": "#779ef3fc-17a1-47f9-b899-bd60cb6996e9",
			"icon":"map-pin-solid"
		},
		{
			"state": "REQUEST_LEAD_TIME",
			"textForm": "Jetzt Preis und Lieferdatum anfragen",
			"directLink": "#779ef3fc-17a1-47f9-b899-bd60cb6996e9",
			"icon":"hard-drive-solid"
		},
		{
			"state": "ORDER_IN_ADVANCE",
			"textForm": "Im Markt vorreservieren",
			"directLink": "#1946cb49-f42c-4e42-b13a-05016fed4c59",
			"icon":"location-dot-solid"
		},
		{
			"state": "REQUEST_CONTRACT",
			"textForm": "Angebot anfordern",
			"directLink": "#779ef3fc-17a1-47f9-b899-bd60cb6996e9",
			"icon":"file-lines-solid"
		},
		{
			"state": "INFORM_CUSTOMER",
			"textForm": "Artikel anfragen",
			"directLink": "#779ef3fc-17a1-47f9-b899-bd60cb6996e9",
			"icon":""
		},
		{
			"state": "SEARCH_STORE",
			"textForm": "Fachmarkt finden",
			"directLink": "#aa70ae6b-0a8b-43ab-9766-aabdbde33eba",
			"icon":"location-dot-solid"
		}
	],
	"combinedAvailability": [
		{ "state": "AVAILABLE", "textForm": "sofort verfügbar" },
		{ "state": "PREORDER", "textForm": "Vorbestellbar" },
		{ "state": "PROCURABLE", "textForm": "Beschaffbar" },
		{ "state": "SOLD_OUT", "textForm": "Ausverkauft" },
		{ "state": "NOT_IN_STORE", "textForm": "Nur Online" },
		{ "state": "NEXT_DAYS_AVAILABLE", "textForm": "kurzfristig verfügbar" },
		{ "state": "ONLY_IN_STORE", "textForm": "Nur im Fachmarkt" },
		{ "state": "NOT_AVAILABLE", "textForm": "Nicht verfügbar" }
	],
	"redirectButtonAction": [
		{
			"state": "REDIRECT",
			"textForm": "Zum Artikel"
		}
	]
}
